import { render } from "./DrawerChat.vue?vue&type=template&id=6c429209"
import script from "./DrawerChat.vue?vue&type=script&lang=ts"
export * from "./DrawerChat.vue?vue&type=script&lang=ts"
script.render = render

export default script